import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-intercompany-adjustment',
  templateUrl: './intercompany-adjustment.component.html'
})
export class IntercompanyAdjustmentComponent implements OnInit {
  companies: any[] = [];
  data: any = { remark: '', amount: '' };
  history: any = { collection: [], summary: [], total: 0, page: 1 };
  filter: any = { date_from: '', date_to: '', company: '' };
  busy = false;
  loading = false;
  error = '';
  message = '';
  // Retain the exact payload across uncertain responses; never re-key a retry.
  pending: any = null;
  constructor(public http: HttpService) {}
  async ngOnInit() { await this.refresh(); }
  get from() { return this.companies.find(c => c.uuid === this.data.from_company); }
  get to() { return this.companies.find(c => c.uuid === this.data.to_company); }
  get fromBank() { return this.from?.banks.find(b => b.id == this.data.from_bank); }
  get toBank() { return this.to?.banks.find(b => b.id == this.data.to_bank); }
  get amount() { return Number(this.data.amount) || 0; }
  get valid() {
    return this.fromBank && this.toBank && this.from !== this.to && this.from.currency &&
      this.from.currency === this.to.currency && this.amount > 0 && /^\d{1,12}(\.\d{1,2})?$/.test(String(this.data.amount)) && this.data.remark.trim();
  }
  async refresh() {
    this.loading = true;
    try {
      const result: any = await this.http.post('/admin/intercompany-adjustment/options');
      if (!result?.status) throw new Error(result?.message || 'Unable to load companies.');
      this.companies = result.companies;
      await this.loadHistory(1);
    } catch (e: any) { this.error = e.message; }
    finally { this.loading = false; }
  }
  async loadHistory(page = 1) {
    this.loading = true;
    try {
      const result: any = await this.http.post('/admin/intercompany-adjustment/history', { ...this.filter, page });
      if (!result?.status) throw new Error(result?.message || 'Unable to load history.');
      this.history = result;
    } catch (e: any) { this.error = e.message; }
    finally { this.loading = false; }
  }
  async submit() {
    if (this.busy || !this.valid || this.pending) return;
    if (!confirm(`Confirm ${this.from.name} → ${this.to.name}: ${this.from.currency} ${this.amount.toFixed(2)}? This records a bank ledger adjustment.`)) return;
    this.pending = { ...this.data, request_key: crypto.randomUUID() };
    await this.send();
  }
  async reverse(row: any) {
    if (this.busy || this.pending || row.reversal_of || row.reversed_by) return;
    const reason = prompt(`Reverse the entire transfer ${row.reference}? Enter the reason:`);
    if (!reason?.trim()) return;
    this.pending = { reversal_of: row.reference, remark: reason.trim(), request_key: crypto.randomUUID() };
    await this.send();
  }
  async send() {
    if (this.busy || !this.pending) return;
    this.busy = true; this.error = ''; this.message = '';
    try {
      const result: any = await this.http.post('/admin/intercompany-adjustment/post', this.pending);
      if (!result?.status) {
        if (result?.rejected) this.pending = null;
        throw new Error(result?.message || 'Result uncertain. Retry the same request.');
      }
      this.message = 'Completed. Reference: ' + result.reference;
      this.pending = null;
      this.data = { remark: '', amount: '' };
      await this.refresh();
    } catch (e: any) { this.error = e.message; }
    finally { this.busy = false; }
  }
}
